import { useContext, useEffect, useState } from "react";
import AppContext from "../../context";
import { readableColor } from "color2k";
import variables from "../../styles/export.module.scss";
import redFelt from "../../assets/red-felt.webp";
import blackFelt from "../../assets/black-felt.webp";
import greenFelt from "../../assets/green-felt.webp";
import blueFelt from "../../assets/blue-felt.webp";
import anthraciteAntislip from "../../assets/anti-slip_anthracite.webp";
import blackAntislip from "../../assets/anti-slip_black.webp";
import blueJadeAntislip from "../../assets/anti-slip_blue_jade.webp";
import brownAntislip from "../../assets/anti-slip_brown.webp";
import grayAntislip from "../../assets/anti-slip_gray.webp";
import pruneAntislip from "../../assets/anti-slip_prune.webp";
import greenAntislip from "../../assets/anti-slip_sage_green.webp";
import taupeAntislip from "../../assets/anti-slip_taupe.webp";
import deleteIcon from "../../assets/icons/remove-divider.svg";

const Bottoms = () => {
  const [optionsDropdownActive, setOptionsDropdownActive] = useState(false);
  const {
    selectedMaterial,
    selectedBottomType,
    triggerPriceUpdate,
    handleSetSelectedBottomType,
    handleSetSelectedBottomColor,
    handleSetBottomRequired,
    bottomRequiredSwitchDisabled,
  } = useContext(AppContext);
  const labelStyle = {
    color: readableColor(variables.menuBgColor),
  };

  const options = [
    { type: "felt", name: "Red", image: redFelt },
    { type: "felt", name: "Black", image: blackFelt },
    { type: "felt", name: "Green", image: greenFelt },
    { type: "felt", name: "Blue", image: blueFelt },
    { type: "non-slip", name: "Anthracite", image: anthraciteAntislip },
    { type: "non-slip", name: "Black", image: blackAntislip },
    { type: "non-slip", name: "Blue Jade", image: blueJadeAntislip },
    { type: "non-slip", name: "Brown", image: brownAntislip },
    { type: "non-slip", name: "Gray", image: grayAntislip },
    { type: "non-slip", name: "Prune", image: pruneAntislip },
    { type: "non-slip", name: "Green", image: greenAntislip },
    { type: "non-slip", name: "Taupe", image: taupeAntislip },
  ];

  return (
    <>
      <div className="bottoms" id="bottoms">
        <p className="bottoms--title title is-size-6" style={labelStyle}>
          Bottoms
        </p>
        <div className="materials__columns is-multiline">
          <button
            className={`bottoms--button reset-button ${
              selectedBottomType === "wood" ? "selected" : ""
            }`}
            style={labelStyle}
            disabled={selectedMaterial?.name === "Cedar"}
            onClick={() => {
              handleSetSelectedBottomType("wood");
              handleSetSelectedBottomColor(null, "wood");
              handleSetBottomRequired(true);
              triggerPriceUpdate();
            }}
          >
            <img
              src={
                selectedMaterial
                  ? selectedMaterial?.featuredImage?.originalSrc
                  : null
              }
              alt={
                selectedMaterial
                  ? selectedMaterial?.featuredImage?.altText
                  : "material"
              }
              width="28"
              height="28"
            />
            <span style={{ color: readableColor(variables.accentColor) }}>
              Wood
            </span>
          </button>
          <button
            className={`bottoms--button reset-button ${
              selectedBottomType === "felt" ? "selected" : ""
            }`}
            style={labelStyle}
            disabled={selectedMaterial?.name === "Cedar"}
            onClick={() => {
              handleSetSelectedBottomType("felt", "Red");
              handleSetSelectedBottomColor("Red", "felt");
              handleSetBottomRequired(true);
              triggerPriceUpdate();
            }}
          >
            <img src={redFelt} alt="red felt color" width="28" height="28" />
            <span style={{ color: readableColor(variables.accentColor) }}>
              Felt
            </span>
          </button>
          <button
            className={`bottoms--button reset-button ${
              selectedBottomType === "non-slip" ? "selected" : ""
            }`}
            style={labelStyle}
            disabled={selectedMaterial?.name === "Cedar"}
            onClick={() => {
              handleSetSelectedBottomType("non-slip", "Anthracite");
              handleSetSelectedBottomColor("Anthracite", "non-slip");
              handleSetBottomRequired(true);
              triggerPriceUpdate();
            }}
          >
            <img
              src={anthraciteAntislip}
              alt="Anthracite non-slip color"
              width="28"
              height="28"
            />
            <span style={{ color: readableColor(variables.accentColor) }}>
              Non-Slip
            </span>
          </button>
          <label
            className={`bottoms--input ${
              selectedBottomType === "none" ? "selected" : ""
            } ${bottomRequiredSwitchDisabled ? "is-disabled" : ""}`}
          >
            <img
              src={deleteIcon}
              alt={
                selectedMaterial
                  ? selectedMaterial.node?.featuredImage?.altText
                  : "bottom type"
              }
              width="28"
              height="28"
            />
            <span style={{ color: readableColor(variables.accentColor) }}>
              None
            </span>
            <input
              type="radio"
              id="bottom-required"
              disabled={selectedBottomType === "none"}
              style={labelStyle}
              onClick={() => {
                handleSetBottomRequired(false);
                handleSetSelectedBottomType("none");
                handleSetSelectedBottomColor(null, "none");
                triggerPriceUpdate();
              }}
            />
          </label>
        </div>
        {(selectedBottomType === "felt" ||
          selectedBottomType === "non-slip") && (
          <div
            className={`dropdown ${optionsDropdownActive ? "is-active" : ""}`}
          >
            <div className="dropdown-trigger mt-2" style={{ width: "100%" }}>
              <button
                className="button is-fullwidth is-outlined"
                onClick={() => setOptionsDropdownActive(!optionsDropdownActive)}
              >
                <span>
                  {selectedBottomType === "wood" ? "Material" : "Color"}
                </span>
                <span className="icon is-small">
                  <i className="fas fa-angle-down" aria-hidden="true"></i>
                </span>
              </button>
            </div>
            <div
              className="dropdown-menu"
              style={{ width: "100%" }}
              id="bottom-option-menu"
              role="menu"
            >
              <div className="dropdown-content pt-0 pb-0">
                {options
                  .filter(({ type }) => selectedBottomType === type)
                  .map(({ name, image }, index) => {
                    return (
                      <div key={index}>
                        {index > 0 && (
                          <hr
                            className="dropdown-divider"
                            style={{ margin: "0" }}
                          />
                        )}
                        <div
                          className="template-dropdown-item pl-2 is-clickable is-flex is-flex-direction-row is-align-items-center py-2"
                          role="button"
                          onClick={() => {
                            setOptionsDropdownActive(false);
                            if (selectedBottomType === "felt")
                              window?.setFeltColour(name);
                            else window?.setAntislipColour(name);
                            handleSetSelectedBottomColor(
                              name,
                              selectedBottomType
                            );
                          }}
                        >
                          <div className="is-relative image is-24x24">
                            <img
                              style={{
                                position: "absolute",
                                objectFit: "cover",
                                width: "100%",
                                height: "100%",
                              }}
                              src={image}
                              alt=""
                              width="28"
                              height="28"
                            />
                          </div>
                          <div className="ml-2 is-flex is-flex-direction-column is-align-items-flex-start">
                            <p className="is-size-6 has-text-dark  is-size-6">
                              {name}
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        )}
      </div>
      <hr className="horizontal"></hr>
    </>
  );
};

export default Bottoms;
